import { useTranslations } from '@vocab/react';
import { Text, Stack, Box, Heading } from 'braid-design-system';

import { Carousel } from 'src/components/Carousel/Carousel';
import { LoadingItem } from 'src/components/LoadingBlock/LoadingBlock';
import { TIPS } from 'src/components/Router';

import translations from './.vocab';
import { ProgressBar } from './ProgressBar/ProgressBar';
import { Tip } from './Tip/Tip';
import { useScore } from './data';

const progressBarLabelId = 'profileStrengthLabel';

export const Tips = () => {
  const { t } = useTranslations(translations);
  const {
    score: { tips, progress },
    loading,
    error,
  } = useScore();
  const tipsComplete = !loading && (progress === 1 || tips.length === 0);

  const showLoading = Boolean(loading || error);

  return (
    <Box
      id={TIPS}
      display="flex"
      flexDirection="column"
      data={{
        automation: `tips${showLoading ? '-loading-card' : ''}`,
      }}
    >
      <Stack space="large">
        <div aria-hidden="true">
          {showLoading ? (
            <LoadingItem type="heading" level="3" width="large" />
          ) : (
            <Heading level="3" id={progressBarLabelId}>
              {t('Profile strength')}
            </Heading>
          )}
        </div>
        {showLoading ? (
          <LoadingItem type="text" size="standard" width="full" />
        ) : (
          <ProgressBar progress={progress} labelId={progressBarLabelId} />
        )}
        {tipsComplete ? (
          <Stack space="medium" data={{ automation: 'no-tips-message' }}>
            <Heading level="4">{t('Well done!')}</Heading>
            <Text>
              {t(
                'Your profile helps employers better understand what you can do.',
              )}
            </Text>
          </Stack>
        ) : null}
        {showLoading ? (
          <Stack space="large">
            <LoadingItem type="text" size="standard" lines={2} />
            <LoadingItem type="button" />
          </Stack>
        ) : (
          <Carousel items={tips} component={Tip} />
        )}
      </Stack>
    </Box>
  );
};
